<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="logs"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>HISTÓRICO DE TRANSFERÊNCIA DE PEDIDOS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.company_from_name="{ item }">
      {{ item.company_from_code }} - {{ item.company_from_name }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.company_to_name="{ item }">
      {{ item.company_to_code }} - {{ item.company_to_name }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.provider="{ item }">
      {{ getProvider(item) }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.mail="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="getUrl(item.id)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-email-open
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
    </template>

    <template v-slot:no-data>
      Não Existe Histórico de Transferência para ser Exibido
    </template>
  </v-data-table>
</template>
<script>
import { URL } from "@/api/config";
import * as HTTP from "@/api/requests/base";

export default {
  data: () => ({
    search: "",
    loading: false,
    headers: [],
    logs: [],
    isProvider: false,
    companySessionSelected: {
      id: "",
    },
  }),
  computed: {},
  created() {
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
      }
      this.initialize();
    } else {
      this.initialize();
    }
  },
  methods: {
    async initialize() {
      if (this.$route.name === "TransferLogProvider") {
        this.isProvider = true;
        this.headers = [
          {
            text: "Data",
            value: "created_at",
            width: 100,
          },
          { text: "Empresa Origem", value: "company_from_name", width: 200 },
          { text: "Pedido Origem", value: "code_from", width: 100 },
          { text: "Empresa Destino", value: "company_to_name", width: 200 },
          { text: "Pedido Destino", value: "code_to", width: 100 },
          // { text: "TESTE", value: "mail", width: 80, align: "center" },
        ];
      } else {
        this.headers = [
          {
            text: "Data",
            value: "created_at",
            width: 100,
          },
          { text: "Empresa Origem", value: "company_from_name", width: 200 },
          { text: "Pedido Origem", value: "code_from", width: 100 },
          { text: "Empresa Destino", value: "company_to_name", width: 200 },
          { text: "Pedido Destino", value: "code_to", width: 100 },
          { text: "Fornecedor", value: "provider", width: 200 },
          // { text: "TESTE", value: "mail", width: 80, align: "center" },
        ];
      }
      this.getLogs();
    },
    async getLogs() {
      this.loading = true;
      this.logs = [];
      try {
        let url = `${URL}order/log-transfer`;
        if (this.companySessionSelected.id !== "") {
          url = `${url}?franchise=${this.companySessionSelected.id}`;
        }
        let res = await fetch(url);
        this.logs = await res.json();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getProvider(item) {
      if (typeof item.order_detail.id === "undefined") {
        return "";
      }
      if (typeof item.order_detail.provider.id === "undefined") {
        return "";
      } else {
        return `${item.order_detail.provider.code} - ${item.order_detail.provider.name}`;
      }
    },
    getUrl(id) {
      window.open(`${URL}order/transfer-mail/${id}`, "_blank");
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
